import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "style", "type", "explainText", "followUpText", "operateBtn"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import classNames from '@jd/jmtd-tools/es/classnames';
import Modal from '../Modal';
import staticModal from '../ModalStatic';
import modalTypes from './modalTypes';

var ModalTips = function ModalTips(_ref) {
  var className = _ref.className,
      style = _ref.style,
      type = _ref.type,
      explainText = _ref.explainText,
      followUpText = _ref.followUpText,
      operateBtn = _ref.operateBtn,
      other = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Modal, _extends({
    className: classNames('jmtd-modal-tips', className)
  }, other), /*#__PURE__*/React.createElement("div", {
    style: style,
    className: classNames('jmtd-modal-tips-content', {
      'jmtd-modal-tips-no-operate': !operateBtn
    })
  }, /*#__PURE__*/React.createElement("span", {
    className: "jmtd-modal-img jmtd-modal-img-".concat(type)
  }), /*#__PURE__*/React.createElement("div", {
    className: "jmtd-modal-tips-explain-text"
  }, explainText), followUpText && /*#__PURE__*/React.createElement("div", {
    className: "jmtd-modal-tips-follow-text"
  }, followUpText), operateBtn && /*#__PURE__*/React.createElement("div", {
    className: "jmtd-modal-tips-operate-btn"
  }, operateBtn)));
};

ModalTips.propTypes = _objectSpread(_objectSpread({}, Modal.propTypes), {}, {
  type: PropTypes.string,
  // 弹框类型 success warning danger info help
  explainText: PropTypes.node,
  // icon下方描述文字
  followUpText: PropTypes.node,
  // 描述文字下方动作（比如 3s后自动跳转到某页）
  operateBtn: PropTypes.node // 操作按钮

});
ModalTips.defaultProps = _objectSpread(_objectSpread({}, Modal.defaultProps), {}, {
  type: 'success',
  explainText: '',
  followUpText: '',
  operateBtn: ''
}); // // 向 ModalTips 组件添加静态方法

var _modalTypes = modalTypes(staticModal(ModalTips)),
    help = _modalTypes.help,
    warning = _modalTypes.warning,
    danger = _modalTypes.danger,
    success = _modalTypes.success,
    confirm = _modalTypes.confirm;

ModalTips.help = help;
ModalTips.warning = warning;
ModalTips.danger = danger;
ModalTips.success = success;
ModalTips.confirm = confirm;
export default ModalTips;